import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { tagName } from '../../../helpers/element.helper';
import { DRAG_TRIGGER_REGISTERED_EVENT } from '../shared/events/drag-drop.events';

@customElement(tagName('drag-trigger'))
export class DragTriggerComponent extends TmElement {
  override render() {
    return html` <slot></slot> `;
  }

  protected override firstUpdated() {
    this.dispatchLocalEvent({ eventName: DRAG_TRIGGER_REGISTERED_EVENT });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-drag-trigger': DragTriggerComponent;
  }
}
